import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function TutorialSection() {
  const categoryArticles = categories.map((cat) => ({
    ...cat,
    latestArticles: articles.filter((a) => a.category === cat.slug).slice(0, 2),
  }));

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
            使用教程
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            快速上手<strong className="text-primary-500">91浏览器</strong>
          </h2>
          <p className="text-foreground-600 text-sm max-w-2xl mx-auto">
            从入门到精通，分类教程助您全面掌握91浏览器的各项功能
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {categoryArticles.map((cat) => (
            <div key={cat.slug} className="bg-background-50 rounded-xl border border-background-200/70 p-6">
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${cat.icon} text-primary-600 text-base`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950">{cat.name}</h3>
                </div>
                <Link
                  to={`/category/${cat.slug}`}
                  className="text-xs text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap flex items-center gap-1"
                >
                  全部文章
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </Link>
              </div>
              <p className="text-sm text-foreground-600 mb-4">{cat.description}</p>
              <div className="space-y-3">
                {cat.latestArticles.map((article) => (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="flex items-center gap-3 group py-2 -mx-2 px-2 rounded-lg hover:bg-background-100 transition-colors"
                  >
                    <div className="w-16 h-12 rounded-lg overflow-hidden flex-shrink-0">
                      <img
                        src={article.imageUrl}
                        alt={article.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                        {article.title}
                      </h4>
                      <span className="text-xs text-foreground-500">{article.date} · {article.readTime}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/tutorials"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            浏览全部教程
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}